// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","event":"_3CiLu","icon":"_27Oiq","date":"_2HJqF","title":"_2gI2b"};